export default __webpack_public_path__ + "static/media/usdt.db86d455.png";